export interface AnalyticsClient {
  pageViewEvent(url);
}

export enum AnalyticsEventNames {
  PAGE_VIEW_EVENT = 'pageViewEvent'
}
